// Central content source for American Armor Coatings

export const COMPANY = {
  name: "American Armor Coatings",
  short: "American Armor",
  phone: "615-431-0528",
  phoneHref: "tel:16154310528",
  email: "James@americanarmorcoatings.com",
  emailHref: "mailto:James@americanarmorcoatings.com",
  hours: "Mon – Fri  8:30 AM – 6:00 PM CT",
  city: "Hendersonville, Tennessee",
  region: "Serving Tennessee, Kentucky, Alabama, Georgia & the Southeast",
  facilitySqFt: "8,000",
  maxLength: "20 ft",
  maxWidth: "10 ft",
  address: {
    locality: "Hendersonville",
    region: "TN",
    postal: "37075",
    country: "US",
  },
  social: {
    facebook: "https://www.facebook.com/americanarmorcoatings",
    instagram: "https://www.instagram.com/aac_615",
    tiktok: "https://www.tiktok.com/@aac615",
  },
};

export const IMAGES = {
  heroSparks: "https://images.pexels.com/photos/17245900/pexels-photo-17245900.jpeg",
  welding: "https://images.pexels.com/photos/37517094/pexels-photo-37517094.jpeg",
  powder1: "https://images.pexels.com/photos/36184235/pexels-photo-36184235.jpeg",
  powder2: "https://images.pexels.com/photos/36215202/pexels-photo-36215202.jpeg",
  boltDetail: "https://images.pexels.com/photos/257759/pexels-photo-257759.jpeg",
  rustedParts: "https://images.pexels.com/photos/3066795/pexels-photo-3066795.jpeg",
  forklift: "https://images.pexels.com/photos/14688876/pexels-photo-14688876.jpeg",
  warehouse: "https://images.unsplash.com/photo-1645736315000-6f788915923b",
  steelTexture: "https://images.unsplash.com/photo-1466121239823-b0bdb9e64631",
};

export const SERVICES = [
  {
    slug: "industrial-powder-coating",
    title: "Industrial Powder Coating",
    tag: "Heavy-Duty Manufacturing",
    short: "Production-grade coatings for fabricators, OEMs, and manufacturers running high-volume programs.",
    image: IMAGES.powder2,
    bullets: [
      "Parts up to 20 ft long × 10 ft wide",
      "Two production ovens, two spray booths",
      "Weekly, monthly, and JIT scheduling",
      "3D-printed masking fixtures for repeatable results",
    ],
  },
  {
    slug: "commercial-powder-coating",
    title: "Commercial Powder Coating",
    tag: "Signage, Fixtures, Equipment",
    short: "Durable, uniform finishes for storefront fixtures, restaurant equipment, and light commercial assemblies.",
    image: IMAGES.powder1,
    bullets: [
      "Consistent color match across large runs",
      "TGIC polyester, hybrid, and epoxy chemistries",
      "Batch and rack processing",
      "Fast turnaround for tenant improvements",
    ],
  },
  {
    slug: "architectural-powder-coating",
    title: "Architectural Powder Coating",
    tag: "AAMA 2603 / 2604 Class Finishes",
    short: "Long-life exterior coatings for railings, façades, canopies, storefronts, and structural steel.",
    image: IMAGES.powder2,
    bullets: [
      "AAMA-class weatherable powders",
      "Warranty-backed color and gloss retention",
      "Coordinated with GCs and installers",
      "Handles long structural members",
    ],
  },
  {
    slug: "media-blasting",
    title: "Media Blasting",
    tag: "Surface Preparation Done Right",
    short: "Large-format blast room with steel shot, aluminum oxide, and specialty media for SSPC-quality prep.",
    image: IMAGES.heroSparks,
    bullets: [
      "Large walk-in blast room",
      "SSPC-SP profile targets on request",
      "Rust, mill scale, and paint removal",
      "Prep for coating, welding, or inspection",
    ],
  },
  {
    slug: "chemical-stripping",
    title: "Chemical Stripping",
    tag: "Non-Destructive Coating Removal",
    short: "Dedicated chemical strip tank removes old paint, powder, and e-coat without warping thin-gauge parts.",
    image: IMAGES.rustedParts,
    bullets: [
      "Immersion strip tank",
      "Safe for aluminum and thin steel",
      "Removes powder, e-coat, and enamels",
      "Reduces media consumption vs blast-only",
    ],
  },
  {
    slug: "motorcycle-powder-coating",
    title: "Motorcycle Powder Coating",
    tag: "Frames, Wheels, Components",
    short: "Show-quality powder coating for frames, swingarms, wheels, calipers, and engine components.",
    image: IMAGES.boltDetail,
    bullets: [
      "Custom color matching",
      "Candy, metallic, and textured finishes",
      "Precision masking of bearing surfaces",
      "Fast lead times for builders",
    ],
  },
  {
    slug: "automotive-powder-coating",
    title: "Automotive Powder Coating",
    tag: "Restoration & Aftermarket",
    short: "OEM-quality finishes for frames, suspensions, wheels, engine bays, and restoration projects.",
    image: IMAGES.boltDetail,
    bullets: [
      "Chassis and roll cage capacity",
      "High-temp coatings for headers & brakes",
      "Wheel-specific fixturing",
      "Coordinated with restoration shops",
    ],
  },
];

export const INDUSTRIES = [
  "General Contractors",
  "Metal Fabricators",
  "Architects & Designers",
  "Structural Engineers",
  "OEM Manufacturers",
  "Government Contractors",
  "Aerospace & Defense",
  "Automotive & Restoration",
  "Signage & Displays",
  "Agriculture & Heavy Equipment",
  "Energy & Utilities",
  "Purchasing & Procurement",
];

export const PROCESS = [
  { n: "01", title: "Request & Consult", body: "Submit specs, drawings, or samples. We review scope, chemistry, and scheduling within one business day." },
  { n: "02", title: "Intake & Inspection", body: "Parts are received, tagged, and inspected against your PO. Non-conformances are flagged before prep begins." },
  { n: "03", title: "Surface Preparation", body: "Chemical strip, blast, or wash — chosen to match your substrate, coating spec, and end-use environment." },
  { n: "04", title: "Masking & Fixturing", body: "3D-printed masking plugs and custom fixtures protect threads, bores, and mating surfaces with repeatable accuracy." },
  { n: "05", title: "Powder Application", body: "Electrostatic spray in one of two booths. Color, chemistry, and film build controlled to written spec." },
  { n: "06", title: "Cure & QC", body: "Full cure in one of two ovens. Cross-hatch adhesion, mil-thickness, and gloss checks documented per lot." },
  { n: "07", title: "Package & Ship", body: "Parts are un-masked, protected, and packaged for freight, LTL, or customer pickup on schedule." },
];

export const CAPABILITIES = [
  { label: "Facility", value: "8,000 sq ft" },
  { label: "Max Part Length", value: "20 ft" },
  { label: "Max Part Width", value: "10 ft" },
  { label: "Cure Ovens", value: "Two" },
  { label: "Spray Booths", value: "Two" },
  { label: "Blast Room", value: "Walk-in" },
  { label: "Chemical Strip", value: "Immersion Tank" },
  { label: "Material Handling", value: "Forklifts + Overhead" },
  { label: "Masking", value: "3D-Printed Fixtures" },
  { label: "Turnaround", value: "Fast / Scheduled" },
  { label: "Volume", value: "High / Recurring" },
  { label: "Location", value: "Hendersonville, TN" },
];

export const FAQS = [
  { q: "What is the largest part you can coat?", a: `We routinely handle parts up to ${COMPANY.maxLength} long and ${COMPANY.maxWidth} wide. Our two ovens and two spray booths are sized for structural steel, long extrusions, and large weldments.` },
  { q: "What is your typical turnaround time?", a: "Most standard-color production jobs run 5–10 business days from receipt. Recurring programs and JIT schedules can be tighter. Rush timelines are available on request." },
  { q: "Do you handle both large production runs and one-off restoration parts?", a: "Yes. We are set up for weekly and monthly OEM programs, and we also take on motorcycle, automotive, and one-off architectural work with the same QC discipline." },
  { q: "What surface preparation methods do you offer?", a: "Media blasting in a large walk-in blast room, chemical stripping in a dedicated immersion tank, and combined prep for parts requiring both. We match prep to substrate and coating spec." },
  { q: "Do you provide AAMA-class architectural finishes?", a: "Yes. We stock and specify AAMA 2603 and AAMA 2604 class powders for exterior architectural work, with documented warranty support from the powder manufacturer." },
  { q: "Can you match a specific color or RAL?", a: "We match RAL, Federal Standard, and custom color chips. For high-volume programs we stock your color to guarantee lot-to-lot consistency." },
  { q: "Do you serve customers outside of Tennessee?", a: "Yes. Our core service area is Tennessee, Kentucky, Alabama, and Georgia, with regular shipments across the Southeast. We coordinate freight and LTL for larger loads." },
  { q: "How do I get a quote?", a: `Submit the Request a Quote form or call ${COMPANY.phone}. Drawings, part lists, and photos speed up the process. We respond within one business day.` },
];

export const NAV = {
  primary: [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    {
      label: "Services",
      to: "/services",
      mega: SERVICES.map(s => ({ label: s.title, to: `/services/${s.slug}`, desc: s.tag })),
    },
    { label: "Industries", to: "/industries" },
    { label: "Process", to: "/process" },
    { label: "Capabilities", to: "/capabilities" },
    { label: "Gallery", to: "/gallery" },
    { label: "FAQ", to: "/faq" },
    { label: "Contact", to: "/contact" },
  ],
};
